import { IOffer, IOfferCard } from '../../../../types';
import { isNewbuilding } from '../../utils';

export const prepareOffer = (offer: IOffer) => {
  const { isCianPartner, externalOfferUrl, fullUrl, showGalleryThumbnails, dealType, offerType, newbuilding } = offer;

  return {
    ...offer,
    href: isCianPartner ? externalOfferUrl : fullUrl,
    isWide: !!showGalleryThumbnails,
    isNewbuilding: isNewbuilding({ dealType, offerType, newbuilding } as IOfferCard),
    isTop: !!offer.isTop3,
  };
};
